export default __webpack_public_path__ + "static/media/Hiring Poster.ded1a693.jpg";